import { IconLightning } from "@tine/designsystem-icons/sharp";
import { Group } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import { Link } from "wouter";
import BarcodeScannerButton from "../../components/barcodes/BarcodeScannerButton";
import MainColumn from "../../components/common/MainColumn";
import FavoriteListButton from "../../components/FavoriteListButton";
import LoginButton from "../../components/login/LoginButton";
import NewCustomerButton from "../../components/login/NewCustomerButton";
import StoreLogoComponent from "../../components/StoreLogoComponent";
import SearchField from "../../components/search/SearchField";
import authStore from "../../stores/auth/authStore";
import uiStore from "../../stores/uiStore";
import MiniCart from "../minicart/MiniCart";
import UserMenu from "./UserMenu";

const className = cn(["bg-base-0", "w-full", "h-[75px]"]);
const DesktopSearchBar = () => (
   <div className={className}>
      <MainColumn>
         <Group className={className}>
            <div className="mr-auto flex items-center">
               <Link to="/" data-testid="header-logo">
                  <StoreLogoComponent placement="searchbar" />
               </Link>
               <div className="ml-12 mr-4 min-w-fit lg:min-w-[--search-input-min-width]">
                  <SearchField />
               </div>
               {uiStore.accessLevel === 2 && (
                  <div className="font-bold text-error-600">
                     <IconLightning /> Du har nå KS-tilgang. Last på nytt (F5) for å avslutte.
                  </div>
               )}
               {authStore.isLoggedIn() && (
                  <div>
                     <BarcodeScannerButton />
                  </div>
               )}
            </div>
            {authStore.isLoggedIn() ? (
               <>
                  <div>
                     <FavoriteListButton />
                  </div>
                  <div className="pl-1 pr-2">
                     <UserMenu />
                  </div>
               </>
            ) : (
               <>
                  <LoginButton />
                  <div className="pl-2 pr-4">
                     <NewCustomerButton />
                  </div>
               </>
            )}
            <div>
               <MiniCart />
            </div>
         </Group>
      </MainColumn>
   </div>
);

export default observer(DesktopSearchBar);
